<cmps-dialog>
    <cmps-dialog-header [closeTooltip]="_i18n._763_CLOSE | translate">
        <div>
            <div
                class="cmps-ca-guide-picker-dialog--title"
                tabindex="-1"
            >
                {{ _i18n.__GUIDE_CONFIRMATION | translate }}
            </div>
            <div
                class="cmps-ca-guide-picker-dialog--subtitle cmps-cdk-color-grey-400"
            >
                {{ _i18n._11343_SELECT_GUIDE_SUBTITLE | translate }}
            </div>
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body aria-live="polite">
        <!-- View 1: Recommended -->
        <div *ngIf="_view === 'recommended'">
            <div
                *ngIf="_pickedGuide != null"
                class="cmps-ca-guide-picker-dialog--rec-label cmps-cdk-color-green-100"
            >
                <cmps-icon
                    svgIcon="check-circle-outline"
                    class="cmps-cdk-w-14px cmps-cdk-h-14px cmps-cdk-nested:cmps-cdk-w-inherit cmps-cdk-nested:cmps-cdk-h-inherit cmps-cdk-fill-green-100"
                    aria-hidden="true"
                ></cmps-icon>
                {{ _i18n._11344_RECOMMENDED_GUIDE | translate }}
            </div>
            <div *ngIf="_pickedGuide == null">
                {{ _i18n.__THERE_IS_NO_RECOMMENDED_GUIDE_ | translate }}
            </div>
            <!-- TODO: replace hardcoded reasonText with API field (e.g. g.recommendedReason) -->
            <cmps-ca-guide-card
                *ngIf="_pickedGuide != null"
                [guide]="_pickedGuide"
                [picked]="true"
                [reasonText]="
                    'Based on the current commitment type and the performer\'s active metrics, this guide will walk you through drafting an effective commitment together.'
                "
            ></cmps-ca-guide-card>
        </div>

        <!-- View 2: Guide Library -->
        <div *ngIf="_view === 'library'">
            <div
                class="cmps-ca-guide-picker-dialog--library-label cmps-cdk-color-grey-400"
            >
                {{ _i18n._11345_AVAILABLE_GUIDES | translate }}
            </div>
            <cmps-radio-group
                [value]="_selectedLibraryGuide?.guideConfigId"
                [attr.aria-label]="_i18n._11345_AVAILABLE_GUIDES | translate"
            >
                <div class="cmps-ca-guide-picker-dialog--guide-list">
                    <div
                        *ngFor="let g of _sortedGuides"
                        class="cmps-ca-guide-picker-dialog--guide-item"
                        [class.cmps-ca-guide-picker-dialog--guide-item--selected]="
                            g.guideConfigId ===
                            _selectedLibraryGuide?.guideConfigId
                        "
                        tabindex="0"
                        (click)="_onLibraryGuideSelect(g.guideConfigId)"
                    >
                        <div
                            class="cmps-ca-guide-picker-dialog--guide-item-left"
                        >
                            <div
                                class="cmps-ca-guide-picker-dialog--guide-item-name"
                            >
                                {{ g.name }}
                                <cmps-badge
                                    *ngIf="g.recommended === true"
                                    [cmpsBadge]="
                                        _i18n._11353_RECOMMENDED | translate
                                    "
                                    cmpsBadgeClassName="cmps-cdk-bg-color-green-100"
                                    class="cmps-ca-guide-picker-dialog--guide-item-rec-tag"
                                ></cmps-badge>
                            </div>
                            <div
                                class="cmps-ca-guide-picker-dialog--guide-item-details cmps-cdk-color-grey-400"
                            >
                                {{ g.numOfGroups }}
                                {{ _i18n._11346_SECTIONS | translate }} ·
                                {{ g.numOfAreas }}
                                {{ _i18n._11347_QUESTIONS | translate }}
                            </div>
                        </div>
                        <cmps-radio [value]="g.guideConfigId"></cmps-radio>
                    </div>
                </div>
            </cmps-radio-group>
        </div>

        <!-- Disposition — outside view *ngIf so cmps-comment is never destroyed once created -->
        <div
            #dispositionRef
            *ngIf="_dispositionShown"
            class="cmps-ca-guide-picker-dialog--disposition"
            [class.cmps-cdk-d-none]="_view !== 'library'"
            [class.cmps-ca-guide-picker-dialog--disposition--disabled]="
                _selectedLibraryGuide == null ||
                _selectedLibraryGuide.recommended === true
            "
            [attr.aria-disabled]="
                _selectedLibraryGuide == null ||
                _selectedLibraryGuide.recommended === true
            "
        >
            <div class="cmps-ca-guide-picker-dialog--disposition-label">
                {{ _i18n._11348_WHY_DIFFERENT_GUIDE | translate }}
                <span class="cmps-cdk-color-red-100">*</span>
            </div>
            <div
                class="cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4p cmps-cdk-w-100pct"
            >
                <cmps-comment
                    [placeholder]="
                        _i18n._11349_DISPOSITION_PLACEHOLDER | translate
                    "
                    [showToolbar]="true"
                    [ngModel]="_dispositionComment"
                    (ngModelChange)="_onDispositionChange($event)"
                    #commentRef
                ></cmps-comment>
            </div>
        </div>

        <!-- Footer -->
        <div
            class="cmps-ca-guide-picker-dialog--footer"
            *ngIf="_view === 'recommended'"
        >
            <button
                class="cmps-cdk-border-color-grey-400 cmps-cdk-color-grey-400 not:disabled:hover:cmps-cdk-bg-color-grey-400 not:disabled:focus:cmps-cdk-bg-color-grey-400 not:disabled:hover:cmps-cdk-color-white not:disabled:focus:cmps-cdk-color-white not:disabled:hover:cmps-cdk-pseudo-child not:disabled:focus:cmps-cdk-pseudo-child"
                cmpsOutlineButton
                (click)="_switchToLibrary()"
                *ngIf="
                    _caService.state?.meetingRequestContext?.guides?.length > 1
                "
                type="button"
            >
                <span cmpsButtonLabel>
                    {{ _i18n.__SELECT_A_DIFFERENT_GUIDE | translate }}
                </span>
            </button>
            <button
                cmpsButton
                [disabled]="_pickedGuide == null"
                (click)="_onContinueClick()"
                type="button"
            >
                <span cmpsButtonLabel>
                    {{ _i18n._11350_CONFIRM_GUIDE | translate }}
                </span>
            </button>
        </div>
        <div
            class="cmps-ca-guide-picker-dialog--footer"
            *ngIf="_view === 'library'"
        >
            <button
                class="cmps-cdk-border-color-grey-400 cmps-cdk-color-grey-400 not:disabled:hover:cmps-cdk-bg-color-grey-400 not:disabled:focus:cmps-cdk-bg-color-grey-400 not:disabled:hover:cmps-cdk-color-white not:disabled:focus:cmps-cdk-color-white not:disabled:hover:cmps-cdk-pseudo-child not:disabled:focus:cmps-cdk-pseudo-child"
                cmpsOutlineButton
                (click)="_switchToRecommended()"
                type="button"
            >
                <span cmpsButtonLabel>{{ _i18n._121_CANCEL | translate }}</span>
            </button>
            <button
                cmpsButton
                [disabled]="_confirmLibraryBtnDisabled"
                (click)="_onConfirmLibraryClick()"
                type="button"
            >
                <span cmpsButtonLabel>
                    {{ _i18n._11351_CONFIRM_SELECTED_GUIDE | translate }}
                </span>
            </button>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
